module.exports = __webpack_public_path__ + "img/tag-usa.339732f1.svg";